import React from 'react';
import './Link.css';

interface Props {
  title: string;
  content?: JSX.Element; // Optional for links that need to open dialogs.
  onClickHandler: (title: string, content?: JSX.Element) => void;
  selected?: boolean;
}

const Link: React.FC<Props> = ({ title, content, onClickHandler, selected }) => {
  return (
    <div className={`landing_link ${selected ? 'selected' : ''}`} onClick={() => onClickHandler(title, content)}>
      {title}
    </div>
  );
};

export default Link;
